module.exports = __webpack_public_path__ + "media/img/logo-emblem-9662d518dd17c08d9be60ba5bb098277.png";